<template>
  <v-dialog v-model="visible" persistent max-width="480">
    <v-card>
      <v-card-title>Desativar {{ singularLabel }}</v-card-title>
      <v-card-text>
        Tem certeza de que deseja desativar o tamanho
        <strong>{{ size ? size.value : "" }}</strong
        >? Ele deixará de aparecer como opção nos novos cadastros.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="loading" @click="visible = false">
          Cancelar
        </v-btn>
        <v-btn color="red" dark :loading="loading" @click="confirm">
          Desativar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { deleteSize } from "../../../services/sizes";

export default {
  name: "SizeDeleteDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
      validator: (value) => ["clothes", "shoes"].includes(value),
    },
    size: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    singularLabel() {
      return this.type === "clothes" ? "tamanho de roupa" : "tamanho de sapato";
    },
  },
  methods: {
    async confirm() {
      if (!this.size || !this.size.id) return;

      this.loading = true;
      try {
        await deleteSize(this.type, this.size.id);
        this.$emit("deleted");
        this.visible = false;
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
